const MASK_REGEX = {
  9: /\d/,
  A: /[A-Za-z\u0410-\u044f\u0401\u0451\xc0-\xff\xb5]/,
  '*': /[\dA-Za-z\u0410-\u044f\u0401\u0451\xc0-\xff\xb5]/,
};

const MASK_CHARS = Object.keys(MASK_REGEX);

export default function makeMask() {
  let empty = true;
  let cursor = 0;
  let cursorCurr = 0;

  return function (value = '', mask, placeholder) {
    const pattern = placeholder;
    const rexps = {};
    const input = this.refs.input;

    mask.split('').forEach((char, i) => {
      // eslint-disable-next-line no-bitwise
      if (~MASK_CHARS.indexOf(char)) {
        rexps[i + 1] = MASK_REGEX[char];
      }
    });

    let cursorMax = 0;
    let cursorMin = 0;
    let newValue = '';
    let nextChar;

    for (let i = 0; i < mask.length; i++) {
      // eslint-disable-next-line no-bitwise
      if (~MASK_CHARS.indexOf(mask[i])) {
        cursorMin = i;
        break;
      }
    }

    for (let i = 0, j = 0; i < mask.length; ) {
      // eslint-disable-next-line no-bitwise
      if (!~MASK_CHARS.indexOf(mask[i])) {
        newValue += mask[i];
        if (mask[i] === value[j]) {
          j++;
        }
        i++;
        // eslint-disable-next-line no-cond-assign
      } else if ((nextChar = value.substr(j++, 1))) {
        if (rexps[newValue.length + 1].test(nextChar)) {
          newValue += nextChar;
          cursorMax = newValue.length;
          i++;
        }
      } else {
        newValue = newValue.substr(0, cursorMax);
        newValue += pattern.slice(cursorMax);
        break;
      }
    }

    cursorCurr = input ? input.selectionStart : 0;

    const removing = cursor > cursorCurr;

    cursorMax = Math.max(cursorMax, cursorMin);

    if (cursorCurr <= cursorMin) {
      cursorCurr = cursorMin;
    } else if (cursorCurr >= cursorMax) {
      cursorCurr = cursorMax;
    } else if (removing) {
      for (let i = cursorCurr; i >= 0; i--) {
        cursorCurr = i;
        if (rexps[i] && !rexps[i + 1]) break;
        if (rexps[i] && rexps[i + 1] && rexps[i + 1].test(newValue[i])) {
          break;
        }
      }
    } else {
      for (let i = cursorCurr; i <= cursorMax; i++) {
        cursorCurr = i;
        if (!rexps[i + 1] && rexps[i]) break;
        if (rexps[i + 1] && rexps[i + 1].test(newValue[i])) {
          if (!rexps[i]) {
            cursorCurr++;
          }
          break;
        }
      }
    }

    empty = cursorMax === cursorMin;
    cursor = cursorCurr;

    return { value: newValue, cursor, empty };
  };
}
